import React, { useState } from "react";
import { Popover } from "react-tiny-popover";
import { MapTool } from "@shared/types/tools";
import { useSnapshot } from "valtio";
import { toolState } from "@shared/states/uiStates";
import { ColorsSelector } from "@shared/Toolbar/TextButton/TextPopup";
import LinePathIcon from "@assets/icons/line-path.svg?react";
import { ArrowPathSvg } from "@assets/icons/ArrowPathSvg";
import { Tooltip } from "@shared/components/Tooltip";
import { clsx } from "clsx";
import { Button } from "@shared/components/Button";
import { PopoverContent } from "@shared/components/PopoverContent";

interface PencilPopupProps {}

const PencilPopup: React.FC<PencilPopupProps> = (props) => {
	const toolSnap = useSnapshot(toolState);
	const toolProps = toolSnap.properties[MapTool.PENCIL];
	const [isOpen, setIsOpen] = useState(false);

	return (
		<>
			<Popover
				isOpen={isOpen}
				positions={["right"]}
				content={
					<PopoverContent>
						<PencilOptions />
					</PopoverContent>
				}
				onClickOutside={() => setIsOpen(false)}
			>
				<div className={"absolute -right-2 -bottom-2"}>
					<div
						onClick={() => setIsOpen(!isOpen)}
						className={
							"border border-slate-400 w-3 h-3 rounded-full m-2 hover:cursor-pointer"
						}
						style={{ background: toolProps.color }}
					></div>
				</div>
			</Popover>
		</>
	);
};

export const PencilOptions: React.FC = () => {
	const toolSnap = useSnapshot(toolState);
	const toolProps = toolSnap.properties[MapTool.PENCIL];

	const handleSelectColor = (color: string) => {
		toolState.properties[MapTool.PENCIL].color = color;
	};

	const handleSelectArrow = (arrow: boolean) => () => {
		toolState.properties[MapTool.PENCIL].isArrow = arrow;
	};

	return (
		<>
			<div className={"flex gap-2 justify-around"}>
				<Tooltip content={"Arrow [a]"}>
					<Button
						className={clsx({
							"bg-content-primary": toolProps.isArrow,
							"bg-transparent": !toolProps.isArrow,
						})}
						size={"icon-lg"}
						style={{ color: toolProps.color }}
						onClick={handleSelectArrow(true)}
					>
						<ArrowPathSvg />
					</Button>
				</Tooltip>
				<Tooltip content={"Line [L]"}>
					<Button
						className={clsx({
							"bg-content-primary": !toolProps.isArrow,
							"bg-transparent": toolProps.isArrow,
						})}
						size={"icon-lg"}
						style={{ color: toolProps.color }}
						onClick={handleSelectArrow(false)}
					>
						<LinePathIcon width={30} height={30} />
					</Button>
				</Tooltip>
			</div>
			<ColorsSelector color={toolProps.color} onSelect={handleSelectColor} />
		</>
	);
};

export { PencilPopup };
